
import api from 'api';

export const types = {
  LIST_LOCALE_REQUEST: 'app/lists/locale/REQUEST',
  LIST_LOCALE_RECEIVE: 'app/lists/locale/RECEIVE',

  LIST_COUNTRY_REQUEST: 'app/lists/country/REQUEST',
  LIST_COUNTRY_RECEIVE: 'app/lists/country/RECEIVE',

  LIST_RESIDENCE_COUNTRY_REQUEST: 'app/lists/residenceCountry/REQUEST',
  LIST_RESIDENCE_COUNTRY_RECEIVE: 'app/lists/residenceCountry/RECEIVE',

  LIST_RESIDENCE_STATE_REQUEST: 'app/lists/residenceState/REQUEST',
  LIST_RESIDENCE_STATE_RECEIVE: 'app/lists/residenceState/RECEIVE',

  COLOR_THEME_REQUEST: 'app/colorTheme/REQUEST',
  COLOR_THEME_RECEIVE: 'app/colorTheme/RECEIVE',

};


function request(apiName, typeName) {
  return () => dispatch => {
    return api.listsApi[apiName]()
      .then((collection) => dispatch({
        type: typeName,
        payload: { collection },
      }));
  }
}

function receive(typeName) {
  return (collection) => ({
    type: typeName,
    payload: {
      collection,
    },
  });
}

const actions = {
  locale: {
    request: request('locale', types.LIST_LOCALE_RECEIVE),
    receive: receive(types.LIST_LOCALE_RECEIVE),
  },
  country: {
    request: request('country', types.LIST_COUNTRY_RECEIVE),
    receive: receive(types.LIST_COUNTRY_RECEIVE),
  },
  residenceCountry: {
    request: request('residenceCountry', types.LIST_RESIDENCE_COUNTRY_REQUEST),
    receive: receive(types.LIST_RESIDENCE_COUNTRY_RECEIVE),
  },
  residenceState: {
    request: request('residenceState', types.LIST_RESIDENCE_STATE_REQUEST),
    receive: receive(types.LIST_RESIDENCE_STATE_RECEIVE),
  },
  colorTheme: {
    request: request('colorTheme', types.COLOR_THEME_RECEIVE),
    receive: receive(types.COLOR_THEME_RECEIVE),
  },
};

export default actions;
